class BuildTags {
}
/** Hash the last time inertia was built */
BuildTags.buildHash = '38cb3aa1';
/** Version of the package.json file the last time inertia was built */
BuildTags.packageVersion = '1195.0.3';
/** Time inertia was built in UTC */
BuildTags.buildTime = 'Tue, 01 Sep 2026 19:01:00 GMT';
/** Time inertia was built in Boston time */
BuildTags.buildTimeBoston = '2026-09-01 15:01:24 Boston';
/** Detailed build tags string */
BuildTags.detailed = 'BuildTags: 2026-09-01 15:01:24 Boston - 38cb3aa1 - 1195.0.3';
export default BuildTags;
